<template>
  <div>
    
    <b-row>
      <b-col cols="9">
        <div>
          <h2>{{ $t("checklist.pendencies.approved") }}</h2>
        </div>
        <div>
          <pendencies-export
            :fields="fields"
            :table-filters="tableFilters"
            :pagination-per-page="tablePerPage"
            :pendencyStatus="2"
          >
          </pendencies-export>
        </div>
      </b-col>
      <b-col cols="3" style="display:flex; justify-content:flex-end; align-items:flex-end;">
        <base-event-timer
          :timer.sync="eventTimer"
          :lastRefreshTime="lastRefreshTime"
        ></base-event-timer>
        <!-- {{eventTimer}} -->
      </b-col>
    </b-row>

    <div>
      <b-table
        ref="table"
        id="my-table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        current-page="0"
        :filter.sync="tableFilters"
        :filter-debounce="500"
        selectable
        :select-mode="tableSelectMode"
        @context-changed="contextChanged"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </template>
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.key"
              class="vertical-align"
            >
              <div>
                <div v-if="field.key == 'approvalDate'">
                  <base-filter-date
                    ref="baseFilterDate"
                    :dateFill.sync="tableFilters.approvalDate"
                    :dateBegin.sync="tableFilters.approvalDateBegin"
                    :dateEnd.sync="tableFilters.approvalDateEnd"
                    :filterName.sync="field.label"
                    :optionFilterDate.sync="optionFilterDateApproval"
                    v-model="tableFilters[field.key]"
                  ></base-filter-date>
                </div>
                <div v-else-if="field.key == 'pendencyCreated'">
                  <base-filter-date
                    ref="baseFilterDate"
                    :dateFill.sync="tableFilters.pendencyCreated"
                    :dateBegin.sync="tableFilters.dateCreateBegin"
                    :dateEnd.sync="tableFilters.dateCreateEnd"
                    :filterName.sync="field.label"
                    :optionFilterDate.sync="optionFilterDateCreate"
                    v-model="tableFilters[field.key]"
                  ></base-filter-date>
                </div>
                <b-form-input
                  v-else-if="
                    tableFilters[field.key] != null && field.key != 'exportType'
                  "
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(checklistId)="data">
          <router-link
            v-if="module != '0'"
            :to="
              '/module/pendencies/PedenciesDetails/' +
              data.item.checklistId +
              moduleId
            "
          >
            <p>
              <u>
                {{ data.value }}
              </u>
            </p>
          </router-link>
          <router-link
            v-else
            :to="'/checklist/form/filled/details/' + data.item.checklistId"
          >
            <p>
              <u>
                {{ data.value }}
              </u>
            </p>
          </router-link>
        </template>
        <template v-slot:cell(action)="data">
          <div v-if="moduleId">
            <router-link
              v-if="data.item.approvalDate != null"
              :to="
                '/module/pendencies/PedenciesDetails/' +
                data.item.id +
                '/' +
                moduleId
              "
            >
              <b-button size="sm">{{ $t("checklist.form.Details") }}</b-button>
            </router-link>
            <router-link
              v-else
              :to="
                '/module/pendencies/PedenciesDetails/' +
                data.item.id +
                '/' +
                moduleId
              "
            >
              <b-button size="sm">
                {{ $t("checklist.form.Details") }}
              </b-button>
            </router-link>
          </div>
          <div v-else>
            <router-link
              v-if="data.item.approvalDate != null"
              :to="'/checklist/Layout/form/PedenciesDetails/' + data.item.id"
            >
              <b-button size="sm">{{ $t("checklist.form.Details") }}</b-button>
            </router-link>
            <router-link
              v-else
              :to="'/checklist/Layout/form/PedenciesDetails/' + data.item.id"
            >
              <b-button size="sm">
                {{ $t("checklist.form.Details") }}
              </b-button>
            </router-link>
          </div>
        </template>
      </b-table>
    </div>
    <div>
      <table-pagination-range
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
        @homePage="homePage"
        @prevPage="prevPage"
        @nextPage="nextPage"
      >
      </table-pagination-range>
    </div>

    <!-- <pre class="language-json"><code>tableItems: {{ tableItems  }}</code></pre> -->
    <!-- <pre class="language-json"><code>paginationEnd: {{ paginationEnd  }}</code></pre> -->
    <!-- <pre class="language-json"><code>paginationEndList: {{ paginationEndList  }}</code></pre> -->
  </div>
</template>

<script>
import TablePaginationRange from "@/components_rms/base/TablePaginationRange.vue";
export default {
  components: {
    TablePaginationRange,
    BaseFilterDate: () => import("@/components_rms/base/BaseFilterDate.vue"),
    PendenciesExport: () =>
      import("@/pagesRms/checklist/pendency/PendenciesExport.vue"),
    BaseEventTimer: () => import("@/components_rms/base/BaseEventTimer.vue"),
  },
  props: {
    moduleId: String,
  },
  data: function () {
    return {
      fields: [
        {
          key: "action",
          sortable: false,
          label: "",
          thStyle: "width: 110px",
        },

        {
          key: "id",
          filterKey: "id",
          sortable: false,
          label: "Pendência",
          thStyle: "width: 110px",
        },
        {
          key: "checklistId",
          filterKey: "checklistId",
          sortable: false,
          label: "Checklist",
          thStyle: "width: 110px",
        },
        {
          key: "formSearchKey",
          filterKey: "formSearchKey",
          sortable: true,
          label: "Chave de busca",
          thStyle: "width: 200px",
        },
        {
          key: "formName",
          filterKey: "formName",
          sortable: false,
          label: "Formulário",
        },
        {
          key: "pendencyCreated",
          filterKey: "pendencyCreated",
          sortable: false,
          label: "Criação da pendência",
          filterType: "dateRangeCreate",
          formatter: (value, key, item) => {
            let date = new Date(item.creationDate);
            return date.toLocaleString();
          },
        },
        {
          key: "pendencyDescription",
          filterKey: "pendencyDescription",
          sortable: false,
          label: "Descrição",
        },
        {
          key: "approvalDate",
          filterKey: "approvelDate",
          sortable: false,
          label: "Data da Aprovação",
          filterType: "dateRangeApprovel",
          formatter: (value, key, item) => {
            if (item.approvalDate) {
              let date = new Date(item.approvalDate);
              return date.toLocaleString();
            }
            return "";
          },
        },
        {
          key: "approvalUsername",
          filterKey: "approvelUserName",
          sortable: false,
          label: "Responsável pela aprovação",
        },
      ],
      tableFilters: {
        currentPage: 1,
        perPage: 10,
        id: "",
        checklistId: "",
        formName: "",
        formSearchKey: "",
        pendencyCreated: "",
        pendencyDescription: "",
        approvalDate: "",
        approvalUsername: "",
        approvalDateEnd: "",
        approvalDateBegin: "",
        dateCreateBegin: "",
        dateCreateEnd: "",
        exportType: "",
        templateId: "",
      },
      paginationEnd: null,
      paginationEndList: [],
      tableItems: [],
      eventTimer: {
        id: 0,
        userId: 0,
        eventTimerMiliseconds: 0,
        eventTimerSeconds: 0,
        pageUrl: "",
      },
      isBusy: false,
      module: "0",
      tableRowCount: 0,
      tableCurrentPage: 1,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableSelectMode: "single",
      tableSelectedItem: [],
      checklist: {},
      hasAttachments: false,
      optionFilterDateCreate: 0,
      optionFilterDateApproval: 0,
      refreshTime: 0,
      timer: null,
      lastRefreshTime: null,
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  created() {
    if (this.moduleId) this.module = this.moduleId;
    this.myProviderCount();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    init() {
      this.$refs.table.refresh();
    },
    refreshPage() {
      // if (this.eventTimer.eventTimerMiliseconds == 0) return;
      this.timer = setInterval(
        this.init,
        this.eventTimer.eventTimerMiliseconds
      );
    },
    myProvider(ctx, callback) {
      this.lastRefreshTime = new Date();
      this.isBusy = true;
      let apiFilter = {
        currentPage: 1,
        perPage: (ctx.perPage = ctx.perPage),
        id: ctx.filter.id,
        approvalDateBegin: ctx.filter.approvalDateBegin,
        approvalDateEnd: ctx.filter.approvalDateEnd,
        approvalUsername: ctx.filter.approvalUsername,
        checklistId: ctx.filter.checklistId,
        formName: ctx.filter.formName,
        formSearchKey: ctx.filter.formSearchKey,
        pendencyDescription: ctx.filter.pendencyDescription,
        pendencyStatus: 2,
        pendencyCreatedAtBegin: ctx.filter.dateCreateBegin,
        pendencyCreatedAtEnd: ctx.filter.dateCreateEnd,
        paginationDateGreater: null,
        paginationDateLesser: this.paginationEnd,
      };
      this.$apiChecklist
        .post("/pendencies/pagination/list", apiFilter)
        .then((response) => {
          const items = response.data;
          this.isBusy = false;
          this.tableItems = items;
          callback(items);
          // this.refresh();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableItems = [];
            callback([]);
          }
        });
      return null;
    },
    async myProviderCount() {
      let apiFilter = {
        currentPage: 1,
        perPage: this.tablePerPage,
        id: this.tableFilters.id,
        approvalDateBegin: this.tableFilters.approvalDateBegin,
        approvalDateEnd: this.tableFilters.approvalDateEnd,
        approvalUsername: this.tableFilters.approvalUsername,
        checklistId: this.tableFilters.checklistId,
        formName: this.tableFilters.formName,
        formSearchKey: this.tableFilters.formSearchKey,
        pendencyDescription: this.tableFilters.pendencyDescription,
        pendencyStatus: 2,
        pendencyCreatedAtBegin: this.tableFilters.dateCreateBegin,
        pendencyCreatedAtEnd: this.tableFilters.dateCreateEnd,
        paginationDateGreater: null,
        paginationDateLesser: this.paginationEnd,
      };
      this.$apiChecklist
        .post("/pendencies/pagination/count", apiFilter)
        .then((response) => {
          this.tableRowCount = response.data;
          // this.refresh();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.tableRowCount = 0;
          }
        });
    },
    exportPendency(ctx) {
      this.tableFilters.pendencyStatus = 2;
      this.tableFilters.perPage = this.tablePerPage;
      this.tableFilters.currentPage = this.tableCurrentPage;
      this.$apiChecklist
        .request({
          url: "/v2/checklist/pendencyExport/",
          method: "POST",
          data: this.tableFilters,
          responseType: "arraybuffer",
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    homePage(currentPage) {
      this.tableCurrentPage = 1;
      this.paginationEnd = null;
      this.paginationEndList = [];
      this.$refs.table.refresh();
    },
    nextPage(currentPage) {
      if (this.tableItems) {
        if (this.tableItems.length > 0) {
          let nextApprovalDate =
            this.tableItems[this.tableItems.length - 1].approvalDate;
          this.paginationEnd = nextApprovalDate;
          this.paginationEndList.push(nextApprovalDate);
        }
      }
      this.$refs.table.refresh();
    },
    prevPage(currentPage) {
      if (this.paginationEndList.length > 0) {
        this.paginationEndList.splice(this.paginationEndList.length - 1, 1);
      }
      if (this.paginationEndList.length > 0) {
        let nextApprovalDate =
          this.paginationEndList[this.paginationEndList.length - 1];
        this.paginationEnd = nextApprovalDate;
        this.$refs.table.refresh();
      } else {
        this.paginationEnd = null;
        this.$refs.table.refresh();
      }
    },
    contextChanged() {
      this.tableCurrentPage = 1;
      this.paginationEnd = null;
      this.paginationEndList = [];
      this.myProviderCount();
    },
  },
  watch: {
    eventTimer() {
      clearInterval(this.timer);
      this.refreshPage();
    },
  },
};
</script>
<style scoped>
.vertical-align {
  vertical-align: bottom !important;
}
.left {
  margin-left: 0px !important;
}
</style>
